export const APPLICATION_URL = '/application';

export interface RouteInterface {
  name: string;
  path: string;
}

interface RoutesInterface {
  Overview: RouteInterface;
  ApplicationSetup: RouteInterface;
  ApplicationSetupConnectors: RouteInterface;
  ApplicationSetupConsumer: RouteInterface;
  ApplicationSetupNext: RouteInterface;

  Billing: RouteInterface;
  BillingSuccess: RouteInterface;
  BillingFailed: RouteInterface;

  Dashboard: RouteInterface;
  Credentials: RouteInterface;

  Integrations: RouteInterface;
  IntegrationView: RouteInterface;

  Sequences: RouteInterface;
  NewSequences: RouteInterface;

  Consumers: RouteInterface;
  ConsumerView: RouteInterface;
  ConsumerServiceView: RouteInterface;

  Webhooks: RouteInterface;
  Logs: RouteInterface;

  Application: RouteInterface;
  ApplicationView: RouteInterface;
  ApplicationTabView: RouteInterface;
  ApplicationConsumerView: RouteInterface;
  ApplicationConsumerTabView: RouteInterface;

  Login: RouteInterface;
  LoginMfa: RouteInterface;
  LoginCallback: RouteInterface;
  SignUp: RouteInterface;
  SignUpVelory: RouteInterface;

  ForgotPassword: RouteInterface;
  NewPassword: RouteInterface;
  Verify: RouteInterface;

  Settings: RouteInterface;
  AccountSettings: RouteInterface;
  PaymentHistory: RouteInterface;
  WorkspacePlan: RouteInterface;

  Home: RouteInterface;
  Docs: RouteInterface;
  Explorer: RouteInterface;
  RequestInternalIntegration: RouteInterface;
  RequestExternalIntegration: RouteInterface;

  Invite: RouteInterface;

  // PricingPlans: RouteInterface;
}

export const RouteEnum: RoutesInterface = {
  Overview: {
    path: `/overview`,
    name: 'Overview',
  },
  ApplicationSetup: {
    path: `${APPLICATION_URL}/setup`,
    name: 'ApplicationSetup',
  },
  ApplicationSetupConnectors: {
    path: `${APPLICATION_URL}/setup/:applicationId/connectors`,
    name: 'ApplicationSetupConnectors',
  },
  ApplicationSetupConsumer: {
    path: `${APPLICATION_URL}/setup/:applicationId/consumer`,
    name: 'ApplicationSetupConsumer',
  },
  ApplicationSetupNext: {
    path: `${APPLICATION_URL}/setup/:applicationId/next`,
    name: 'ApplicationSetupNext',
  },

  Billing: {
    path: '/billing',
    name: 'Billing',
  },
  BillingSuccess: {
    path: '/billing/success',
    name: 'BillingSuccess',
  },
  BillingFailed: {
    path: '/billing/failed',
    name: 'BillingFailed',
  },

  Dashboard: {
    path: '/dashboard',
    name: 'Dashboard',
  },
  Credentials: {
    path: '/credentials',
    name: 'Credentials',
  },

  Integrations: {
    path: '/integration',
    name: 'Integrations',
  },
  IntegrationView: {
    path: '/integration/:serviceId',
    name: 'IntegrationView',
  },

  Sequences: {
    path: '/sequences',
    name: 'Sequences',
  },
  NewSequences: {
    path: '/sequences/new',
    name: 'New Sequences',
  },

  Consumers: {
    path: '/consumers',
    name: 'Consumers',
  },
  ConsumerView: {
    path: '/consumers/:consumerId',
    name: 'ConsumerView',
  },
  ConsumerServiceView: {
    path: '/consumers/:consumerId/service/:serviceId',
    name: 'ConsumerView',
  },

  Webhooks: {
    path: '/webhooks',
    name: 'Webhooks',
  },
  Logs: {
    path: '/logs',
    name: 'Logs',
  },

  Application: {
    path: APPLICATION_URL,
    name: 'Application',
  },
  ApplicationView: {
    path: `${APPLICATION_URL}/:applicationId`,
    name: 'ApplicationView',
  },
  ApplicationTabView: {
    path: `${APPLICATION_URL}/:applicationId/:tab`,
    name: 'ApplicationView',
  },

  ApplicationConsumerView: {
    path: `${APPLICATION_URL}/:applicationId/consumers/:consumerId`,
    name: 'ApplicationConsumerView',
  },
  ApplicationConsumerTabView: {
    path: `${APPLICATION_URL}/:applicationId/consumers/:consumerId/:consumerTab`,
    name: 'ApplicationConsumerView',
  },

  LoginCallback: {
    path: '/login-callback',
    name: 'LoginCallback',
  },
  LoginMfa: {
    path: '/login-mfa',
    name: 'LoginMfa',
  },
  Login: {
    path: '/login',
    name: 'Login',
  },
  SignUp: {
    path: '/sign-up',
    name: 'SignUp',
  },
  SignUpVelory: {
    path: '/sign-up/velory',
    name: 'SignUpVelory',
  },

  ForgotPassword: {
    path: '/forgot-password',
    name: 'ForgotPassword',
  },
  NewPassword: {
    path: '/new-password/:key',
    name: 'NewPassword',
  },
  Verify: {
    path: '/verify/:key',
    name: 'Verify',
  },

  Settings: {
    path: '/user-settings',
    name: 'Settings',
  },
  AccountSettings: {
    path: '/account-settings',
    name: 'AccountSettings',
  },
  PaymentHistory: {
    path: '/account-settings/payment-history',
    name: 'PaymentHistory',
  },
  WorkspacePlan: {
    path: '/account-settings/workspace-plan',
    name: 'WorkspacePlan',
  },

  Home: {
    path: '/',
    name: 'Home',
  },

  Docs: {
    path: '/docs',
    name: 'Docs',
  },
  Explorer: {
    path: '/explorer',
    name: 'Explorer',
  },
  RequestInternalIntegration: {
    path: '/request/integration',
    name: 'RequestInternalIntegration',
  },
  RequestExternalIntegration: {
    path: '/request/integration/external',
    name: 'RequestExternalIntegration',
  },

  Invite: {
    path: '/invite/:code',
    name: 'Invite',
  },
  // PricingPlans: {
  //   path: '/pricing-plans',
  //   name: 'PricingPlans',
  // },
} as const;
